import CountReducer from './CountReducer';
import SumReducer from './SumReducer';
import AverageReducer from './AverageReducer';
import MaxReducer from './MaxReducer';
import MinReducer from './MinReducer';

export default {
  COUNT: CountReducer,
  SUM: SumReducer,
  AVG: AverageReducer,
  MIN: MinReducer,
  MAX: MaxReducer
};